import { useEffect, useState } from 'react';
import api from '../../services/api';
import { useParams } from 'react-router-dom';
import {
  Row, Col, ListGroup, Button, Form, Tabs, Tab
} from 'react-bootstrap';
import {
  FormCreator,
  FormGroupCreator,
  FormGroupSelector,
  FormConditionEditor,
  FormList,
  FormField,
  FieldList,
  LivePreview
} from '../../components/Form';
import { useUsers } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import Container from '../../layouts/Container';



  // selectedForm,
  // editingFieldId,
  // handleAddField,
  // handleCancelEdit,
  // renderDefaultValueOptions
export default function FormsPage() {
  const { projectId } = useParams();
  
  const [formGroups, setFormGroups] = useState([]);
  const [newGroupName, setNewGroupName] = useState('');
  const [selectedFormGroupId, setSelectedFormGroupId] = useState('');
  
  const [forms, setForms] = useState([]);
  const [formName, setFormName] = useState('');
  const [selectedForm, setSelectedForm] = useState(null);


  const [previewValues, setPreviewValues] = useState({});

  const [editingFieldId, setEditingFieldId] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [formConditionField, setFormConditionField] = useState('');
  const [formConditionValue, setFormConditionValue] = useState('');
  const { user } = useUsers();
  const navigate = useNavigate();

  useEffect(() => {
    const isAnalyst = user?.roles.some(role => role.name == 'GVE_Analyst');
    if (isAnalyst) {
      navigate('/');
    }
  }, [user]);
  useEffect(() => {
    fetchFormGroups();
  }, [projectId]);


  useEffect(() => {
    if (selectedFormGroupId) {
      fetchForms();
    } else {
      setForms([]);
      setSelectedForm(null);
    }
  }, [selectedFormGroupId]);

  const fetchFormGroups = async () => {
    const res = await api.get(`/projects/${projectId}/formgroups`);
    setFormGroups(res.data);

    const activeGroup = res.data.find((g) => g.isActive);
    if (activeGroup) {
      setSelectedFormGroupId(activeGroup.id.toString());
    }
  };

  const handleCreateFormGroup = async () => {
    if (!newGroupName.trim()) return;
  
    const res = await api.post(`/projects/${projectId}/formgroups`, { name: newGroupName });
    await setNewGroupName('');
    await fetchFormGroups();
    setSelectedFormGroupId(res.data.id);
  };  

  const fetchForms = async () => {
    const res = await api.get(`/projects/${projectId}/formgroups/${selectedFormGroupId}`);
  
    // Sort forms by id ascending
    const sortedForms = (res.data || []).sort((a, b) => a.id - b.id);
  
    setForms(sortedForms);
  
    if (sortedForms.length > 0) {
      const currentFormId = selectedForm?.id;
      const matchedForm = sortedForms.find(f => f.id === currentFormId);
  
      const formToSelect = matchedForm || sortedForms[0];
  
      setSelectedForm(formToSelect);
      setActiveTab(formToSelect.id.toString());
  
      if (formToSelect.conditions?.length > 0) {
        const c = formToSelect.conditions[0];
        setFormConditionField(c.dependsOnFieldId.toString());
        setFormConditionValue(c.expectedValue === '__not_empty__' ? '' : c.expectedValue);
      } else {
        setFormConditionField('');
        setFormConditionValue('');
      }
    } else {
      // If no forms, clear selection
      setSelectedForm(null);
      setActiveTab(null);
      setFormConditionField('');
      setFormConditionValue('');
    }
  };

  const handleCreateForm = async () => {
    if (!formName.trim()) return;
    await api.post(`/projects/${projectId}/forms`, { name: formName, formGroupId: selectedFormGroupId });
    setFormName('');
    fetchForms();
  };

  const handleDeleteField = async (fieldId) => {
    const confirm = window.confirm('Are you sure you want to delete this field?');
    if (!confirm) return;
    try {
      await api.delete(`/projects/${projectId}/forms/${selectedForm.id}/fields/${fieldId}`);
      fetchForms();
    } catch (err) {
      console.error('Error deleting field:', err);
      alert('Failed to delete field.');
    }
  };

  const saveFormCondition = async (condition, approverOnly = false) => {
    await api.patch(`/projects/${projectId}/forms/${selectedForm.id}/conditions`, {
      condition,
      approverOnly
    });
    alert('Form condition saved!');
    setFormConditionField('');
    setFormConditionValue('');
    fetchForms();
  };

  const renderDefaultValueOptions = (type, fieldValue, onChange, options = []) => {
    if (type === 'text') {
      return (
        <Form.Control
          value={fieldValue}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    } else if (type === 'number' || type === 'counter' || type === 'currency') {
      return (
        <Form.Control
          value={fieldValue}
          onChange={(e) => onChange(e.target.value)}
          type="number"
        />
      );
    } else if (type === 'checkbox') {
      return (
        <Form.Select value={fieldValue} onChange={(e) => onChange(e.target.value)}>
          <option value={false}>Unchecked</option>
          <option value={true}>Checked</option>
        </Form.Select>
      );
    } else if (type === 'radio' || type === 'dropdown') {
      return(
        <Form.Select
          value={fieldValue === null ? 'GVE_NONE' : fieldValue}
          onChange={(e) => {
            const val = e.target.value;
            onChange(val === 'GVE_NONE' ? null : val);
          }}
        >
          <option value="GVE_NONE">None</option>
          { options.map((option) => (<option value={option}>{option}</option>))}
        </Form.Select>
      );
    }
  }
  return (
    <Container>
      <Row>
        <Col xs={12} md={3}>

        <FormGroupSelector
          formGroups={formGroups}
          selectedFormGroupId={selectedFormGroupId}
          setSelectedFormGroupId={setSelectedFormGroupId}
          projectId={projectId}
          onDuplicate={fetchFormGroups}
          onToggleGroupActive={async (groupId) => {
            await api.patch(`/projects/${projectId}/formgroups/${groupId}/activate`);
            fetchFormGroups();
          }}
        />

        <FormGroupCreator
          newGroupName={newGroupName}
          setNewGroupName={setNewGroupName}
          onCreateGroup={handleCreateFormGroup}
        />

        <FormList
          forms={forms}
          refetchForms={fetchForms}
          selectedForm={selectedForm}
          setSelectedForm={setSelectedForm}
          setActiveTab={setActiveTab}
        />

        <FormCreator
          formName={formName}
          setFormName={setFormName}
          onCreateForm={handleCreateForm}
        />
      </Col>

      <Col xs={12} md={5}>
        {selectedForm && (
          <>
            <h4>Form Builder: {selectedForm.name}</h4>

            <FormConditionEditor
              forms={forms}
              selectedForm={selectedForm}
              formConditionField={formConditionField}
              setFormConditionField={setFormConditionField}
              formConditionValue={formConditionValue}
              setFormConditionValue={setFormConditionValue}
              onSaveCondition={saveFormCondition}
              onRemoveCondition={async () => {
                const confirm = window.confirm('Remove this form condition?');
                if (!confirm) return;
                await api.delete(`/projects/${projectId}/forms/${selectedForm.id}/conditions`);
                alert('Condition removed.');
                fetchForms();
              }}
            />

            <FormField
              selectedForm={selectedForm}
              editingFieldId={editingFieldId}
              setEditingFieldId={setEditingFieldId}
              fields={selectedForm.fields}
              forms={forms}
              projectId={projectId}
              renderDefaultValueOptions={renderDefaultValueOptions}
              onSubmit={fetchForms}
            />

            <FieldList
              fields={selectedForm.fields}
              selectedForm={selectedForm}
              editingFieldId={editingFieldId}
              setEditingFieldId={setEditingFieldId}
              handleDeleteField={handleDeleteField}
              formId={selectedForm?.id}
              projectId={projectId}
              onReorder={fetchForms}
            />

          </>
        )}
      </Col>

      <Col xs={12} md={4}>
        <LivePreview
          forms={forms}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          selectedForm={selectedForm}
          setSelectedForm={setSelectedForm}
          previewValues={previewValues}
          setPreviewValues={setPreviewValues}
        />
      </Col>

    </Row>
  </Container>
  );
}
